import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  CircularProgress,
  Modal,
  Backdrop,
  Fade,
} from "@mui/material";
import { motion } from "framer-motion";
import axios from "axios";

const ServicesPage = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const response = await axios.get("https://wedding-backend-pi.vercel.app/api/services"); // Replace with your API endpoint
        const formattedData = response.data.map((service) => ({
          ...service,
          price: service.price
            ? `₹${service.price}`
            : "Request a Quote",
        }));
        setServices(formattedData);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch services. Please try again.");
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  const handleOpenModal = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedService(null);
  };

  return (
    <Box sx={{ py: 4, px: 2 }}>
      {/* Header Section */}
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: "bold",
          mb: 4,
          textTransform: "uppercase",
          letterSpacing: 2,
        }}
      >
        Our Services
      </Typography>

      <Typography
  variant="h6"
  align="center"
  sx={{
    mb: 4,
    color: "text.secondary",
  }}
>
  For bookings, please contact us or mail us at   <strong>weddingbliss@gmail.com</strong>
 
</Typography>

      {/* Loading Spinner or Error */}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography variant="h6" color="error" align="center">
          {error}
        </Typography>
      ) : (
        <Grid container spacing={3}>
          {/* Services Grid */}
          {services.map((service) => (
            <Grid item xs={12} sm={6} md={4} key={service.id}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <Card
                  sx={{
                    height: 370, // Adjusted for price addition
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    overflow: "hidden",
                  }}
                >
                  {/* Service Image */}
                  <CardMedia
                    component="img"
                    image={service.image}
                    alt={service.title}
                    sx={{
                      height: 150, // Fixed height for the image
                      objectFit: "cover", // Ensure image fits well
                      borderRadius: "4px 4px 0 0",
                    }}
                  />

                  {/* Service Content */}
                  <CardContent
                    sx={{
                      flex: 1, // Allow the content to stretch within the card
                      overflow: "hidden",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        mb: 1,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {service.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2, // Limit to 2 lines
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        mb: 1,
                      }}
                    >
                      {service.description}
                    </Typography>
                    {/* Display Price */}
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: "bold",
                        color: "primary.main",
                      }}
                    >
                      {service.price}
                    </Typography>
                  </CardContent>

                  {/* Call-to-Action Button */}
                  <CardActions>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ textTransform: "capitalize", fontWeight: "bold" }}
                      onClick={() => handleOpenModal(service)}
                    >
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Modal for Service Details */}
      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={isModalOpen}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: 600,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}
          >
            {selectedService && (
              <>
                <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                  {selectedService.title}
                </Typography>
                <CardMedia
                  component="img"
                  image={selectedService.image}
                  alt={selectedService.title}
                  sx={{
                    borderRadius: 2,
                    maxHeight: 300,
                    objectFit: "contain",
                    mb: 2,
                  }}
                />
                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                  {selectedService.description}
                </Typography>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  Price: {selectedService.price}
                </Typography>
                <Box sx={{ textAlign: "right", mt: 2 }}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleCloseModal}
                  >
                    Close
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

export default ServicesPage;










